import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { filter, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { WorkItemModel, WorkItemService, WorkItemType } from 'digiteq-ai-portal-client-lib';
import { MessageService } from 'primeng/api';
import { ContactUsService } from '../../services/contact-us.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit, OnDestroy {
  get showContactUsDialog(): boolean {
    return this.contactUsService.showContactUsDialog;
  }

  set showContactUsDialog(value: boolean) {
    this.contactUsService.showContactUsDialog = value;
  }
  contactForm: FormGroup;
  processingRequest = false;
  routerSub: Subscription;
  types = Object.values(WorkItemType);

  private readonly defaultType = WorkItemType.Bug;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly workItemService: WorkItemService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly contactUsService: ContactUsService,
  ) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required],
      type: [this.defaultType, Validators.required]
    })

    this.routerSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.showContactUsDialog = false;
      });
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }

  submitForm(): void {
    this.processingRequest = true;
    const contactForm: WorkItemModel = this.contactForm.value;
    this.workItemService.createWorkItem(contactForm).subscribe({
      next: () => {
        this.showContactUsDialog = !this.showContactUsDialog;
        this.processingRequest = false;
        this.resetForm();
        this.messageService.add({ severity: 'success', detail: 'Your message was sent and registered.', summary: 'Success', life: 3000 })
      },
      error: () => {
        this.processingRequest = false;
        this.messageService.add({ severity: 'error', detail: 'Could not send your message.', summary: 'Error', life: 3000 })
      }
    });
  }

  resetForm(){
    this.contactForm.reset({type: this.defaultType});
  }
}
